import { useMemo } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import useViewPublicRealPlayQuery from 'features/publicRoleplay/services/queries/useViewPublicRoleplay';
import useSubmitPublicAssignmentMutation from 'features/publicRoleplay/services/mutations/useSubmitPublicAssignment';
import PublicRealPlayHelper from 'features/publicRoleplay/publicRealPlay.helper';
import { format, parseISO } from 'date-fns';
import User from 'infrastructure/User';

const SubmitPublicRoleplayLogic = () => {
  let history = useHistory();
  const { token } = useParams();

  const { isLoading } = useViewPublicRealPlayQuery({
    token,
  });

  const {
    isNotEmpty,
    assigned_by_user,
    assignment_uuid,
    scenarios,
    scenariosCompleted,
    endDate,
    title,
    roleplay_description,
  } = PublicRealPlayHelper();

  const initialLetter = User.getInitial(assigned_by_user);
  const userName = User.getUserName(assigned_by_user);

  const formattedEndDate = format(parseISO(endDate), 'MMM dd, yyyy');

  const { mutate: submitPublicRoleplay, isLoading: isLoadingSubmit } =
    useSubmitPublicAssignmentMutation();

  const handleSubmit = () => {
    submitPublicRoleplay(
      { token, assignment_uuid },
      {
        onSuccess: (response) => {
          history.push(`/public-roleplay/${token}`);
        },
      }
    );
  };

  const enabled = useMemo(
    () => scenarios?.every((item) => item.response && item.response.video),
    [scenarios]
  );

  return {
    isLoading,
    isNotEmpty,
    assigned_by_user,
    scenarios,
    scenariosCompleted,
    title,
    roleplay_description,
    initialLetter,
    userName,
    formattedEndDate,
    handleSubmit,
    enabled,
    isLoadingSubmit,
  };
};
export default SubmitPublicRoleplayLogic;
